import { UserRole } from '../types/users';

export const RESTRICTED_SKU_UPLOAD_ROLES: UserRole[] = [
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.PROCUREMENT_MANAGER,
];
